import { useRef } from "react"
import { ANIMATE_DELAY } from "src/libs/interfaces/animated"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"
import { ILandingSection } from "../../../data/interfaces"
import TitleDummy from "../landing-edit/TitleDummy"
import DescriptionDummy from "../landing-edit/DescriptionDummy"
import { MENU_ITEM_ICON_DIVIDER } from "src/libs/basic-view/ExtendMenu"

/* Protopia Ecosystem component */
export interface ITitleContainerProps {
    section: ILandingSection
    children: JSX.Element | JSX.Element[]
}
const TitleContainer = (props: ITitleContainerProps): JSX.Element => { 
    const isEdit  = useLandingConsoleStore((state:ILandingConsoleStore) => state.isEdit) 
    const section = props.section
    const title = section.title || {}  
    const isLandingEdit = useLandingStore((state: ILandingStore) => state.isEdit)

    /* css class .landing-edit-cont - edit.select container for get bounds */        
    return !!title.text || !!props.section.description?.text
        ?
        <div 
            className={ `landing-section-title-container landing-edit-cont ${ title.container_class_name || "" }` } 
            style={{
                ...props.section.title_container_style, 
            }} 
            context-title={
                isLandingEdit 
                    ? 
                    [
                        `Change Title settings${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}changeTitleSection${MENU_ITEM_ICON_DIVIDER}${props.section.id}`,
                        //`Transform Title`,
                        `Delete Title${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteTitle${MENU_ITEM_ICON_DIVIDER}${props.section.id}`
                    ].join("|||")
                    : 
                    undefined 
                }
        >
            <TitleAnimationContainer {...props}>
                <TitlePositionContainer {...props}>
                    { props.children }
                    { 
                        isEdit && <div className="flex-centered m-1 h_0 " style={{ gap: 20 }}>
                            <TitleDummy section={props.section} />
                            <DescriptionDummy section={props.section} />
                        </div>
                    }
                </TitlePositionContainer>
            </TitleAnimationContainer>
        </div>
        :
        <>
        { 
            isEdit && <div className="w-100 position-absolute z-index-80 " >
                <div className="pl-4 m-1 h_0" >
                    <TitleDummy section={props.section} />
                    <DescriptionDummy section={props.section} />
                </div>
            </div>
        }
        </>
}
export default TitleContainer

const TitleAnimationContainer = (props:ITitleContainerProps): JSX.Element => {
    const title = props.section.title || {} 
    const animated_delay =  title?.animated_delay === ANIMATE_DELAY.WATERFALL
        ?
        ""
        :
        title?.animated_delay || ""
        
    const ref = useRef(null)
    useAnimated( ref, animated_delay ) 
    const animate   = useAnimatedStyle(title, 0)

    return <div className={`title-animation-container ${ animate }`} ref={ ref }>
        { props.children }
    </div>
}

const TitlePositionContainer = (props:ITitleContainerProps): JSX.Element => {
    const title = props.section.title || {} 
    const position = title.position || {}  
    return <div 
        className="title-position-container" 
        style={{
            transform: `scale(${(position.scale || 1 )}) translateX(${position.left || 0}px) translateY(${position.top || 0}px) rotate(${position.rotate || 0}deg)`,
            width: position.width,
            height: position.height,
        }}
    >
        { props.children }
    </div>
}